export const adHocReportingConstants = Object.freeze({
  title: {
    ADHOC_REPORTING_MODAL: 'Run Ad Hoc Report',
    ADHOC_REPORTING_BUTTON: 'RUN AD HOC REPORT',
    ADHOC_REPORTING_MODAL_REDIRECT_BUTTON: 'CONTINUE TO AD HOC REPORT',
    ADHOC_REPORTING_MODAL_CANCEL_BUTTON: 'CANCEL',
  },
  message: {
    ADHOC_REPORTING_REDIRECT_NOTICE:
      'You are about to be redirected to Cognos, a third party that allows you to run an ad hoc version of this report. Please note the following:',
    AHDOC_REPORTING_REDIRECT_NOTE_1:
      'You will need to use a separate login credential previously provided to you by your account manager to access this service.',
    AHDOC_REPORTING_REDIRECT_NOTE_2:
      "If you are familiar with LSL's previous client portal, it is the same credential that allowed you to access that site.",
    AHDOC_REPORTING_REDIRECT_NOTE_3:
      'If you have not been given this credential, have forgotten it, or encounter other issues, please contact your account manager for further assistance.',
  },
})
